import { render, staticRenderFns } from "./TaskStatsDialog.vue?vue&type=template&id=c02e62f0"
import script from "./TaskStatsDialog.vue?vue&type=script&lang=js"
export * from "./TaskStatsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports